import React from 'react';
import * as Icons from 'lucide-react';

// Lista curada de ícones úteis para catálogo de móveis
export const CURATED_ICONS = [
  'Sofa', 'Armchair', 'Table', 'BedDouble', 'Bed', 'DoorClosed', 'DoorOpen',
  'Library', 'BookOpen', 'Tv', 'Monitor', 'MonitorSmartphone', 'PanelTop',
  'Package', 'Package2', 'Archive', 'ArchiveRestore', 'Folder', 'FolderOpen',
  'Building2', 'Users', 'ConciergeBell', 'Utensils', 'LampCeiling', 'LampDesk',
  'Squircle', 'Square', 'Boxes', 'Frame', 'Grid3x3', 'ChefHat',
  'Rows2', 'Rows3', 'Columns2', 'Columns3', 'Home', 'Briefcase', 'Coffee',
  'PenTool', 'Layers', 'Star', 'Heart', 'Sparkles',
];

/**
 * Renderiza um ícone a partir de:
 * - subcategory.icon_url (imagem enviada, prioridade)
 * - subcategory.icon_name (nome de um ícone lucide-react)
 * - fallback: ícone genérico
 */
const CategoryIcon = ({ subcategory, size = 24, className = '', strokeWidth = 1.5 }) => {
  if (subcategory?.icon_url) {
    return (
      <img
        src={subcategory.icon_url}
        alt={subcategory?.name || 'ícone'}
        style={{ width: size, height: size, objectFit: 'contain' }}
        className={className}
      />
    );
  }

  const name = subcategory?.icon_name;
  const LucideIcon = (name && Icons[name]) || Icons.Package;
  return <LucideIcon size={size} strokeWidth={strokeWidth} className={className} />;
};

export default CategoryIcon;
